<template>
  <ThemeProvider>
    <MaintenanceBanner />
    <div class="page-shell">
      <Nav />
      <main
        class="page-main"
        :class="{
          'green-staging': isStaging && isGreen,
          'blue-staging': isStaging && isBlue
        }"
      >
        <div class="content">
          <slot>
            No content passed to show.
          </slot>
        </div>
      </main>
    </div>
  </ThemeProvider>
  <Notifications to=".theme-provider"/>
</template>

<script setup lang="ts">
import Nav from '@/components/bui/organisms/Nav';
import ThemeProvider from '@/components/ThemeProvider';
import Notifications from "@/components/Notifications/Notifications.vue";
import { ref, onMounted } from "vue";
import useDataSourceStore from '@/stores/dataSource';
import MaintenanceBanner from './MaintenanceBanner.vue';
const { activeDataSourceBaseUrl } = useDataSourceStore();

const isStaging = ref(false);
const isGreen = ref(false);
const isBlue = ref(false);
onMounted(() => {
  fetch(`${activeDataSourceBaseUrl}/environment`)
    .then((response) => response.json())
    .then((data) => {
      isStaging.value = data?.env === "STAGE";
      isGreen.value = data?.server === "GREEN";
      isBlue.value = data?.server === "BLUE";
    });
});
</script>

<style lang="scss" scoped>
.page-shell {
  display: flex;
  align-items: stretch;
  min-height: 100vh;
  width: 100%;
}

.page-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.green-staging { background-color: green; }
.blue-staging { background-color: blue; }

.content {
  background-color: white;
  width: 100%;
  padding: 0 1rem;
  margin-bottom: 13rem;
  @include theme-old {
    max-width: 1200px;
    @include screen-width-up("1232px") {
      padding: initial;
    }

    /* The legacy `theme-old` selector outranks a plain `.content:has(...)`
       rule, so the BUI override has to live in here to win the
       specificity battle on wide monitors. */
    &:has(> .bui-entity-listing-page) {
      max-width: none;
      padding: 0;
    }

    &:has(> .bui-dashboard-page) {
      max-width: none;
      padding: 0;
    }
  }
  display: flex;
  flex-direction: column;
  @include x-large-devices-down {
    justify-content: center;
    padding: 1rem;
  }

  /* Default-theme path: hand the canvas over to the BUI listing page so
     the magenta surface bleeds edge-to-edge between sidebar and viewport. */
  &:has(> .bui-entity-listing-page) {
    background-color: var(--bui-page-fill, #ff007b);
    padding: 0;
    max-width: none;
    margin-bottom: 0;
  }

  &:has(> .bui-dashboard-page) {
    background-color: var(--bui-page-fill, #ff007b);
    padding: 0;
    max-width: none;
    margin-bottom: 0;
  }
}
</style>
